import { defineMessage } from 'services/localization';

export const messages = {
    editButtonTitle: defineMessage('edit'),
    editButtonText: defineMessage('edit'),
    startOverButtonTitle: defineMessage('restart_the_approval_workflow_for_this_request'),
    startOverButtonText: defineMessage('start_over_the_workflow'),
    revokeButtonTitle: defineMessage('revoke_the_previous_decision'),
    revokeButtonText: defineMessage('revoke'),
    deleteButtonTitle: defineMessage('remove_the_request'),
    deleteButtonText: defineMessage('remove'),
    cancelButtonTitle: defineMessage('cancel_the_request'),
    cancelButtonTitleScheduledReason: defineMessage('you_cannot_cancel_the_r_as_payment_is_scheduled'),
    cancelButtonText: defineMessage('cancel'),
    deleteConfirmationText: defineMessage('sure'),
    secondaryActions: defineMessage('templatename_actions'),
    reverseButtonTitle: defineMessage('reverse'),
    reverseButtonText: defineMessage('reverse'),
    allocateToXeroCreditNote: defineMessage('add_to_credit_note'),
};
